/**
 * Subscription slice
 */

import { createAction, createSlice } from '@reduxjs/toolkit';
import { SubscriptionAnalytics } from './types';

const initialState = {
  subscriptionAnalytics: null as SubscriptionAnalytics | null,
  loading: false,
  error: null as string | null,
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    setSubscriptionAnalytics(state, action) {
      state.subscriptionAnalytics = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

// Reducer
export const subscriptionReducer = subscriptionSlice.reducer;

// Actions
export const {
  setSubscriptionAnalytics,
  setLoading,
  setError,
  clearError,
} = subscriptionSlice.actions;

// Async Actions
export const fetchSubscriptionAnalytics = createAction('SUBSCRIPTION/FETCH_ANALYTICS');

